import {
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild
} from '@angular/core';
import {NavigationEnd, Router} from '@angular/router';
import {User} from "../user/user";
import {RouteData} from "../shared/services/route-data/route-data";
import {combineLatest, Observable, Subject, Subscription} from "rxjs";
import {RouteDataService} from "../shared/services/route-data/route-data.service";
import {MainHeaderService} from './main-header.service';
import {IActivityNotification} from "../activity-notifications/activity-notification";
import {Store} from "@ngrx/store";
import * as fromStore from "../store";
import {filter, first, switchMap} from 'rxjs/operators';
import {UserSubscription, UserSubscriptionCategory, UserSubscriptionType} from "../user/user-subscription";
import {PaymentDialogComponent} from "../workspace/billing/payment-dialog/payment-dialog.component";
import {DialogService} from "../../ng2-bootstrap-modal/dialog.service";
import {UserSubscriptionStatus} from "../user/user-subscription-status";
import {GlobalEvent} from "../shared/services/global-event-dispatcher/global-event";
import {GlobalEventDispatcherService} from "../shared/services/global-event-dispatcher/global-event-dispatcher.service";
import {Website} from "../websites/website/website";
import {clientRoles} from "../user/user-roles-actions";
import {IWorkspaceIdEntities} from "../store/reducers/workspace.reducer";
import {
  ManageWorkspaceUsersDialogComponent
} from "../shared/components/dialogs/manage-workspace-users-dialog/manage-workspace-users-dialog.component";
import {Workspace} from "../user-managment/workspace";
import {TypeFormAnswers} from "../add-website/typeFormAnswers";
import {ExpertsService} from "../services/API/experts.service";
import {Config} from "../config/config";
import {GoogleAnalyticsService} from "../shared/services/google-analytics/google-analytics.service";
import {TypeUtils} from "../shared/utils/type-utils";
import {CookieService} from "ngx-cookie";
import {UserService} from "../user/user.service";
import {DbModalService} from "../modules/modal/modal";
import {SwitchPlanComponent} from "../components/common/switch-plan/switch-plan.component";
import {Utils} from "../shared/utils/utils";
import {Payment} from "../user/payment";
import {animate, style, transition, trigger} from "@angular/animations";
import {SidebarNavigationService} from "../shared/services/navigation/sidebar-navigation.service";

const PERCENT_OFFER_END_DATE = new Date("2024-01-30 18:00:00").getTime();


@Component({
    selector: 'db-main-header',
    templateUrl: './main-header.component.html',
    styleUrls: ['./main-header.component.scss'],
    animations: [
        trigger('fadeSlideInOut', [
            transition(':enter', [
                style({ opacity: 0, transform: 'translateY(10px)' }),
                animate('0.3s ease', style({ opacity: 1, transform: 'translateY(0)' })),
            ]),
            transition(':leave', [
                animate('0.3s ease', style({ opacity: 0, transform: 'translateY(10px)' })),
            ]),
        ]),
    ],
    standalone: false
})
export class MainHeaderComponent implements OnInit, OnDestroy {

  @ViewChild('mainHeaderContentHost') mainHeaderContentHost: ElementRef;
  @Input() headerTitle: string;
  @Input() toggleSidebar: boolean = false;
  @Input() annualSubscription?: UserSubscription;
  @Input() monthlyPrice?: number;
  @Input() annualPriceForCurrent?: number;
  @Input() isGeo?: boolean;

  @Output() onToggleClick = new EventEmitter<boolean>();
  private _destroyStream$: Subject<boolean> = new Subject<boolean>();

  private _subscriptions: Subscription[];
  public user: User;
  public userSubscription: UserSubscription;
  public currentWorkspace: Workspace;
  public workspaceIdEntities: IWorkspaceIdEntities;
  public newActivityNotifications$: Observable<IActivityNotification[]>;
  public _routeData: RouteData;
  public userSubscriptionStatus = UserSubscriptionStatus;
  public isMobile: boolean = false;
  public isWorkspaceStatusInvited: boolean;
  public isSiteDev: boolean;
  public conditionalPages: boolean;
  public checkPageAndWorkspace: boolean;
  public _price: number;
  public website: Website;
  public websites: Website[];
  public hostedWebsites: Website[];
  public knowLedgeBaseToggled$: Observable<boolean>;
  public openedKnowledgeBase: boolean;
  public currentWorkspaceId: number;
  public hideBuyWebsiteButton: boolean;
  public showActivitiesIcon: boolean;
  public isTrialExpired: boolean;
  public neverWebsiteCreated: boolean;
  public expiredSubscr: boolean;
  public expiredSubscrNotRecharge: boolean;
  public trialOrOptimizerTrial: boolean;
  public workspaceRoles = clientRoles;
  public UserSubscriptionType = UserSubscriptionType;
  public UserSubscriptionCategory = UserSubscriptionCategory;
  public typeFormAnswers = TypeFormAnswers;
  public limitedOfferCondition = false;
  public userLocalStorage: any;
  public showAnniversaryOffer: boolean = false;
  public showPercentOffer: boolean = false;
  public endDate: any;
  public switchingLoading: boolean;
  public anniversaryLeftDays: number = 0;
  public anniversaryLeftHours: number = 0;
  public anniversaryLeftMinutes: number = 0;
  public inGrandSlamPage: boolean;
  public demoUser: boolean = false;
  public clientRoles = clientRoles;
  public payments: Payment[];
  public oneWeekFreeExpired?: boolean;
  public oneWeekFreeNotExpired?: boolean;
  public paidNotExpired?: boolean;
  public hasUpgrade: boolean;
  public hasDomainBuyAccess: boolean = true;
  public disabledForInstanceCreate: boolean = false;
  showBlkOfferTooltip = false;
  hideTooltipTimeout: any;
  campaignInfo: any;

  protected readonly userSubscriptionType = UserSubscriptionType;

  constructor(
    private _router: Router,
    private _store: Store<fromStore.DbStoreState>,
    private _routeDataService: RouteDataService,
    private _dialogService: DialogService,
    private _globalEventDispatcher: GlobalEventDispatcherService,
    private _mainHeaderService: MainHeaderService,
    private _expertsService: ExpertsService,
    private _googleAnalyticsService: GoogleAnalyticsService,
    private _userService: UserService,
    private _cookieService: CookieService,
    private _modalService: DbModalService,
    private sidebarNavigationService: SidebarNavigationService
  ) {
  }

  ngOnInit() {
    this._mainHeaderService.setContentHost(this.mainHeaderContentHost);
    this.knowLedgeBaseToggled$ = this._store.select(fromStore.getKnowledgeBaseToggled);
    this.knowLedgeBaseToggled$.subscribe((isOpened: any) => {
      this.openedKnowledgeBase = isOpened;
    });
    this.addSubscriptions();
    if (this._routeData && this._routeData.queryParams && this._routeData.queryParams.id) {
      this.getWebsite();
    }
    this._globalEventDispatcher.addEventListener(GlobalEvent.userInstanceCreating, this.onDisabledButtons, this);

    this.campaignInfo = this._userService.getCampaignInfo();
  }

  public innerFunctions(): void {
    if (!this.user || !this.userSubscription || !this.currentWorkspace || !this.workspaceIdEntities) {
      return;
    }
    this.currentWorkspaceId = this.workspaceIdEntities.currentWorkspaceId || this.workspaceIdEntities.ownerWorkspaceId;
    const userRole = this.user && this.user.workspaces.find(el => el.workspaceId === this.currentWorkspaceId);
    this.hideBuyWebsiteButton = userRole ? [clientRoles.COMPANY_DEV, clientRoles.SITE_DEV].includes(userRole.roleId) : true;
    this.hasDomainBuyAccess = userRole ? [clientRoles.COMPANY_ADMIN, clientRoles.OWNER].includes(userRole.roleId) : false;

    if (this.userSubscription && this.userSubscription.plan && this.userSubscription.plan.additionalDomainParameterPrice) {
      this._price = this.userSubscription.plan.periodNumber === 12 ? this.userSubscription.plan.additionalDomainParameterPrice / 12 : this.userSubscription.plan.additionalDomainParameterPrice;
      if (this._price % 1 !== 0) {
        this._price = Number(this._price.toFixed(2));
      }
    }
    this.neverWebsiteCreated = this.user && !this.user.websiteCreated && !this.user.websiteConnected;
    this.isWorkspaceStatusInvited = this.currentWorkspace && this.currentWorkspace.status === 'invited';
    this.isSiteDev = this.currentWorkspace && this.currentWorkspace.roleId === clientRoles.SITE_DEV;
    this.newActivityNotifications$ = this._store.select(fromStore.getNewActivityNotifications);
    this.isMobile = window.innerWidth <= 1024;
    this._routeData = this._routeDataService.getCurrentRouteData();
    this.inGrandSlamPage = this._routeData && this._routeData.data && this._routeData.data.pageId === 'agency-special-offer' || window.location.href.indexOf('agency-special-offer') >= 1;
    this.isTrialExpired = this.userSubscription && this.userSubscription.type === UserSubscriptionType.FREE && this.user.hostingTrialExpired;
    this.trialOrOptimizerTrial = this.userSubscription.trialClient || this.userSubscription.trialOptimizerClient;

    let expired = [this.userSubscriptionStatus.canceled, this.userSubscriptionStatus.failed, this.userSubscriptionStatus.expired].includes(this.userSubscription.status) || this.userSubscription.isExpired || this.userSubscription.recharge;

    this.expiredSubscr = expired || this.userSubscription.recharge;

    this.expiredSubscrNotRecharge = [this.userSubscriptionStatus.failed, this.userSubscriptionStatus.expired].includes(this.userSubscription.status) || this.userSubscription.isExpired;
    this.showOrNot();
  }

  public getWebsite(): void {
    this._store
      .select(fromStore.getWebsitesLoaded)
      .pipe(
        filter((loaded: boolean): boolean => !!loaded),
        switchMap(() => this._store.select(fromStore.getWebsite(this._routeData.queryParams.id)))
      )
      .subscribe((website: Website) => {
        this.showOrNot();
        if (website) {
          this.website = website;
        }
      });
  }

  public showOrNot(): void {
    this.conditionalPages = ['migration-steps', 'add-website', 'setup', 'setup-onboarding', 'move-hosting', 'change-hosting', 'optimize', 'buy-speed-optimizer', 'create', 'options', 'other'].includes(this._routeData.pageId);
    this.checkPageAndWorkspace = !this.isWorkspaceStatusInvited && !this.conditionalPages;
    this.showActivitiesIcon = !this.trialOrOptimizerTrial
      || ((this.trialOrOptimizerTrial && this.user && !this.user.hostingTrialExpired) && this._routeData.pageId !== 'add-website');
  }

  public switchPlanToAnnual(): void {
    const analyticsData = {
      eventCategory: 'Dashboard Action',
      eventAction: 'Upgrade to Annual flow',
      eventLabel: 'Open pop-up - Widget btn',
    };
    this._googleAnalyticsService.sendAnalyticsEventWithCore(analyticsData);
    const modal = this._modalService.open(SwitchPlanComponent);
    modal.componentInstance.userSubscription = this.userSubscription;
    modal.componentInstance.demoUser = this.demoUser;
    modal.componentInstance.annualSubscription = this.annualSubscription;
    modal.componentInstance.monthlyPrice = this.monthlyPrice;
    modal.componentInstance.annualPriceForCurrent = this.annualPriceForCurrent;
  }

  private addSubscriptions(): void {
    this._subscriptions = [];

    this._subscriptions.push(
      this._store.select(fromStore.getUserLoaded)
        .pipe(
          filter((loaded: boolean) => loaded),
          switchMap(() => combineLatest(
            this._store.select(fromStore.getUser),
            this._store.select(fromStore.getUserSubscription),
            this._store.select(fromStore.getCurrentWorkspace),
            this._store.select(fromStore.getUserUpgradableSubscription()),
            this._store.select(fromStore.getUserAvailableHostingSubscriptions()),
            this._store.select(fromStore.getWorkspaceIdEntities),
            this._store.select(fromStore.getUserLocalStorage),
            this._store.select(fromStore.getPayments),
            this._store.select(fromStore.getWebsitesLoaded)
              .pipe(
                first(loaded => loaded),
                switchMap(() => this._store.select(fromStore.getWebsites))
              )
          ))
        )
        .subscribe(([user, userSubscription, currentWorkspace, upgradableSubscriptions, availableHostingSubscriptions, workspaceIdEntities, userLocalStorage, payments, websites]) => {
          this.user = user;
          this.userSubscription = userSubscription;
          this.currentWorkspace = currentWorkspace;
          this.workspaceIdEntities = workspaceIdEntities;
          this.websites = websites;
          this.hostedWebsites = websites.filter((website: Website) => website.type === 'live' && website.isActive && !website.isLocalhost && website.domain_hash && !website.isStopped);
          this.userLocalStorage = userLocalStorage;
          this.demoUser = Utils.isDemoUser(userSubscription, user);

          this.hasUpgrade = this.userSubscription && !!upgradableSubscriptions && !(availableHostingSubscriptions.length === 1 && availableHostingSubscriptions.filter((_userSubscription => _userSubscription.tabCategory === this.userSubscription.tabCategory)));

          this.payments = payments && payments.length ? payments.filter((payment) => payment.paymentStatus !== 'failed') : [];
          this._showPercentOffer(this.payments);
          // this._showAnniversary();
          this.innerFunctions();
          // this.setLimitedOfferData();
        })
    );

    this._subscriptions.push(this._router.events
      .pipe(filter((event: any) => event instanceof NavigationEnd))
      .subscribe(() => {
        this._routeData = this._routeDataService.getCurrentRouteData();
        this.inGrandSlamPage = this._routeData && this._routeData.data && this._routeData.data.pageId === 'agency-special-offer' || window.location.href.indexOf('agency-special-offer') >= 1;
        if (this._routeData && (!this._routeData.queryParams || (this._routeData.queryParams && !this._routeData.queryParams.id))) {
          this.website = null;
        }
        this.showOrNot();
      })
    );
    this._globalEventDispatcher.addEventListener(GlobalEvent.hostedWebsitePages, this.onHostedWebsitePages, this);
  }

  ngOnDestroy() {
    this._destroyStream$.next(true);
    this._destroyStream$.complete();
    this._mainHeaderService.unsetContentHost();
    this.removeSubscriptions();
  }

  public onHostedWebsitePages(website) {
    this.website = website;
  }

  private _showAnniversary() {
    const anniversaryEndDate = new Date("2022-11-16 00:00:00").getTime();
    const nowDate = new Date().getTime();
    this.showAnniversaryOffer = false; // nowDate < anniversaryEndDate && this.userSubscription && this.userSubscription.trialBoosterClient;
  }

  private _showPercentOffer(payments: Payment[]) {
    this.oneWeekFreeExpired = payments && !payments.length && this.userSubscription && this.userSubscription.platformPaidClient && this.userSubscription.isExpired;
    this.oneWeekFreeNotExpired = payments && !payments.length && this.userSubscription && this.userSubscription.platformPaidClient && !this.userSubscription.isExpired;
    this.paidNotExpired = this.hasUpgrade && payments && payments.length > 0 && this.userSubscription && this.userSubscription.platformPaidClient && !this.userSubscription.isExpired;

    const nowDate = new Date().getTime();
    const blackFridayEndDate = new Date("2023-11-28 12:00:00").getTime();
    this.showPercentOffer = nowDate < blackFridayEndDate && this.userSubscription && (this.userSubscription.trialClient
      || this.oneWeekFreeExpired || this.oneWeekFreeNotExpired || this.paidNotExpired) && !(this.userSubscription.isAgency && this.userSubscription.category === UserSubscriptionCategory.PREMIUM);
    if (this.showPercentOffer) {
      const endDate = new Date("2023-11-28 12:00:00").getTime();
      this.endDate = endDate;
      const datesDiff = Utils.getTimeDiffFromToday(endDate);
      this.showPercentOffer = datesDiff && this.userSubscription && this.userSubscription && (this.userSubscription.trialClient
        || this.oneWeekFreeExpired || this.oneWeekFreeNotExpired || this.paidNotExpired);
      this._setToLocalStorage(endDate);
    }
  }

  private _setToLocalStorage(endDate) {
    if (!this.userLocalStorage.blkOfferBannerEndDate) {
      this.userLocalStorage = {...this.userLocalStorage, blkOfferBannerEndDate: endDate};
      this._userService.setToLocal(this.userLocalStorage)
        .pipe(
          first(response => !!response),
        )
        .subscribe(response => {
          if (response.success) {
            this._store.dispatch(new fromStore.LoadUserLocalStorage());
          }
        });
    }
  }

  private removeSubscriptions(): void {
    this._subscriptions.forEach((subscription: Subscription): void => {
      subscription.unsubscribe();
    });
    this._subscriptions = null;
  }

  public get customContentElement(): ElementRef {
    return this._mainHeaderService.contentElement;
  }


  public toggleUserSummary(): void {
    if (this.openedKnowledgeBase) {
      this.toggleKnowLedgeBase();
    }
    this._store.dispatch(new fromStore.ToggleUserSummaries());
    this._store.dispatch(new fromStore.LoadHostingResources());
    this._store.dispatch(new fromStore.LoadHostingVisits());
  }

  public toggleActivityNotifications(): void {
    if (this.openedKnowledgeBase) {
      this.toggleKnowLedgeBase();
    }
    this._store.dispatch(new fromStore.ToggleActivityNotifications());
  }

  public toggleKnowLedgeBase(): void {
    if (!this.openedKnowledgeBase) {
      const analyticsData = {
        eventCategory: 'Dashboard Action',
        eventAction: 'Toggle Knowledge Base',
        eventLabel: TypeUtils.isDefined(this._router) && TypeUtils.isDefined(this._router.url) ? this._router.url : ''
      };
      this._googleAnalyticsService.sendAnalyticsEventWithCore(analyticsData);
    }
    this._store.dispatch(new fromStore.ToggleKnowledgeBase());
  }

  public toggleLeftSidebar(): void {
    this.toggleSidebar = !this.toggleSidebar;
    this.onToggleClick.emit(this.toggleSidebar);
    // this.sidebarNavigationService.toggleSidebar();
  }

  public buyNow(): void {
      this._dialogService
        .addDialog(PaymentDialogComponent, {
          upgradeSubscription: this.userSubscription,
          fromDialog: false,
          showAdditional: true
        });
  }

  inviteUsers() {
    if (this.user && this.user.subscriptionId === Config.defaultStarterPlanId) {
      return this.showCheckoutDialog('Invite User');
    }
    if (!this.userLocalStorage.inviteVisited) {
      this._dialogService.addDialog(ManageWorkspaceUsersDialogComponent, {
        isInvite: true,
        ownerEmail: this.user.email,
        userRole: this.user.signUpFor && this.user.signUpFor.Role && this.user.signUpFor.Role.id,
        from: 'header',
        currentSubscription: this.userSubscription,
      });
    } else {
      this._router.navigate(['/user-management'], {queryParams: {'from': 'header'}});
    }

  }

   showCheckoutDialog(label: string): void {
    this.sidebarNavigationService.showUpgradeDialog(label, this.demoUser);
  }

  public expertsRedirectionHandler(roleId: string = null): void {
    /*    if (this.user && this.user.subscriptionId === Config.defaultStarterPlanId
          && this.user.signUpFor && this.user.signUpFor.Role
          && [TypeFormAnswers.AGENCY, TypeFormAnswers.EXPERTS_AGENCY].includes(this.user.signUpFor.Role.id)) {
          return this.showCheckoutDialog('Become an Expert');
        }*/
    if (this.user && this.user.hasExpertsProfile) {
      // go to experts profile
      this._expertsService.redirectToExperts(null, true);
      return;
    }
  }

  private checkLimitedOfferCondition(): boolean {
    return (this.userSubscription && this.userSubscription.trialBoosterClient
      && this.user && this.user.signUpFor && this.user.signUpFor.WebsiteNumber
      && this.user.signUpFor.WebsiteNumber.id !== TypeFormAnswers.FROM_1_TO_3
      && this.userLocalStorage
    );
  }

  private setLimitedOfferData(): void {
    if (!this.checkLimitedOfferCondition()) return;
    if (this.userLocalStorage.limitedOfferStartDate && this.userLocalStorage.limitedOfferStartDate === 'expired') return;
    if (!(this.userLocalStorage.limitedOfferStartDate
      || (!this.userLocalStorage.limitedOfferStartDate && this.websites && this.websites.length >= 2))) return;

    const now = Date.now();
    const diffTime = now - this.userSubscription.agreementDate.getTime();
    const diffTimeMinutes = diffTime / 60_000;
    const expirationDate = (this.userLocalStorage.limitedOfferStartDate || now) + (72 * 3_600_000);
    if (diffTimeMinutes >= 30 * 24 * 60 && now < expirationDate) {

      if (!this.userLocalStorage.limitedOfferStartDate) {
        this.userLocalStorage = {...this.userLocalStorage, limitedOfferStartDate: now};
        this._userService.setToLocal(this.userLocalStorage)
          .pipe(
            first(response => !!response),
          )
          .subscribe(response => {
            if (response.success) {
              this._store.dispatch(new fromStore.LoadUserLocalStorage());
            }
          });
      }
      this._cookieService.put(
        'db-limited-offer-expiration-date',
        String(expirationDate),
        {path: '/', domain: '10web.io'}
      );
      this.limitedOfferCondition = true;
    } else if (now >= expirationDate) {
      this.removeLimitedOfferData();
    }
  }

  private removeLimitedOfferData(): void {
    this._cookieService.remove('db-limited-offer-expiration-date');
    this.userLocalStorage = {...this.userLocalStorage, limitedOfferStartDate: 'expired'};
    this._userService.setToLocal(this.userLocalStorage)
      .pipe(
        first(response => !!response),
      )
      .subscribe(response => {
        if (response.success) {
          this._store.dispatch(new fromStore.LoadUserLocalStorage());
        }
      });
  }

  public onDisabledButtons(hide) {
    this.disabledForInstanceCreate = !!hide;
  }

  onShowTooltip(): void {
    clearTimeout(this.hideTooltipTimeout);
    this.showBlkOfferTooltip = true;
  }

  onHideTooltip(): void {
    this.hideTooltipTimeout = setTimeout(() => {
      this.showBlkOfferTooltip = false;
    }, 500);
  }

  redirectPricingPage(): void {
    this.showBlkOfferTooltip = false;
    this._router.navigate(['/upgrade-plan']);
  }

  @HostListener('window:resize') resize() {
    this.isMobile = window.innerWidth <= 1024;
  }

}
